import project from "@/api/project";

const state = {
    projects: []
};

const getters = {
    projects: state => {
        return state.projects;
    }
};

const actions = {
    get({ commit }) {
        return project
            .get()
            .then(response => {
                if (response.status === 200) {
                    commit("SET_PROJECTS", response.data.data);
                }
                return response;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    },

    store({ commit }, data) {
        return project
            .store(data)
            .then(response => {
                if (response.status === 200) {
                    commit("ADD_PROJECT", response.data.data);
                }
                return response;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    },

    clipStore({ commit }, data) {
        return project
            .clipStore(data)
            .then(response => {
                if (response.status === 200) {
                    commit("ADD_PROJECT_CLIP", {
                        ...response.data.data,
                        project_id: data.project_id
                    });
                }
                return response;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },

    clipDelete({ commit }, data) {
        return project
            .clipDelete(data.project_id, data.clip_id)
            .then(response => {
                if (response.status === 200) {
                    commit("DELETE_PROJECT_CLIP", {
                        ...response.data.data,
                        project_id: data.project_id
                    });
                }
                return response;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },

    userStore({ commit }, data) {
        return project
            .userStore(data)
            .then(response => {
                if (response.status === 200) {
                    commit("ADD_PROJECT_USER", {
                        ...response.data.data,
                        project_id: data.project_id
                    });
                }
                return response;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    }
};

const mutations = {
    SET_PROJECTS(state, value) {
        state.projects = value;
    },
    ADD_PROJECT(state, value) {
        state.projects.push(value);
    },
    ADD_PROJECT_CLIP(state, value) {
        state.projects.forEach(project => {
            if (project.id === value.project_id) {
                project.clips.push(value);
            }
        });
    },
    ADD_PROJECT_USER(state, value) {
        state.projects.forEach(project => {
            if (project.id === value.project_id) {
                project.users.push(value);
            }
        });
    },
    DELETE_PROJECT_CLIP(state, value) {
        console.log(value);
        state.projects.forEach(project => {
            if (project.id === value.project_id) {
                project.clips = project.clips.filter(clip => clip.id !== value.id);
                console.log(project.clips);
            }
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
